import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
import rangePlugin from "./flatpickrRangePlugin";
import NProgress from "./nprogress";

(function ($) {
  // Frontpage countdown timer replace stuff

  $(document).ready(() => {
    // Check if WordPress is set to German
    if ($("html").hasClass("lang-de") || $("html").attr("lang") === "de-DE") {
      // Create a map for translations
      const translations = {
        Hour: "Stunde",
        Hours: "Stunden",
        Day: "Tag",
        Days: "Tage",
        Minute: "Minute",
        Minutes: "Minuten",
        Second: "Sekunde",
        Seconds: "Sekunden",
      };

      // Batch process all matching elements
      $(".eb-cd-label").each(function () {
        const text = $(this).text().trim();
        if (translations[text]) {
          $(this).text(translations[text]);
        }
      });
    }
  });

  // MICE form category joining with ,

  $(".mice-filter-form").on("submit", function (e) {
    e.preventDefault();

    const selectedCategories = [];
    $(".category-checkbox:checked").each(function () {
      selectedCategories.push($(this).val());
    });

    $("#category-input").val(selectedCategories.join(","));

    this.submit();
  });

  // other sitewide code

  const siteTitle = document.querySelector(".entry-title")?.textContent;
  const siteUrl = bmtg_bundle_object.siteurl;
  const themeUrl = `${siteUrl}/wp-content/themes/bmtg`;

  $(document).ready(() => {
    $(window).on("popstate", () => {
      NProgress.done(); // Stop the loading bar
    });

    // Exclude links in the WordPress admin bar
    $(
      `a[href^="${siteUrl}"]:not(#wpadminbar a):not([href$=".pdf"]):not([href$=".jpg"]):not([href$=".jpeg"])`
    ).on("click", () => {
      NProgress.configure({ trickleSpeed: 50 }); // Speed of the trickle in milliseconds
      if (!NProgress.isStarted()) {
        NProgress.start(); // Start the loader
      }
    });
  });

  document.addEventListener("DOMContentLoaded", () => {
    NProgress.done(); // Stop the loader when the new page is loaded
  });

  // Local Storage Test
  function localStorageTest() {
    const test = "test";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  jQuery(document).ready(($) => {
    const lastScroll = 0;

    // Fix Nav

    const topMenu = document.querySelector(".topchecker");
    const adminBar = document.querySelector("#wpadminbar");
    const { body } = document;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const { id } = entry.target;

        if (id === "wpadminbar") {
          if (entry.isIntersecting) {
            body.classList.add("adminbar-visible");
          } else {
            body.classList.remove("adminbar-visible");
          }
        }

        if ($("#menu-toggle").hasClass("toggled-on")) {
          return;
        }
        if (!entry.isIntersecting) {
          body.classList.add("fixed-nav");
        } else if (!body.classList.contains("page-template-page_360")) {
          body.classList.remove("fixed-nav");
        }
      });
    });

    if (topMenu) {
      observer.observe(topMenu);
    }

    if (adminBar) {
      observer.observe(adminBar);
    }

    // CHECK IF ADMINBAR IS IN VIEW

    const alertStatus = localStorage.getItem("alertstatus");
    let alertShown = false;
    if (alertStatus === "show" || alertStatus === null) {
      alertShown = true;
    } else {
      alertShown = false;
    }

    // get all data attributes from #alert with jquery
    const alert = $("#alert").data();
    const alertHtml = `
      <div class="imfokustext ${alertShown === true ? "" : "hide"}">
        <div class="innertextcontent">
          <img src="${themeUrl}/img/triangle-exclamation-solid.svg" width="20" height="20" alt="">
          <h2>${alert?.title}</h2>
          <p>${alert?.text}</p>
          <a href="${alert?.linkurl}" target="${
      alert?.linktarget
    }" class="button fokusfirstbutton">${alert?.linktitle}</a>
          <a href="" class="button ausblendenbutton active">${
            alertShown === true ? "Ausblenden" : "Einblenden"
          }</a>
        </div>
      </div>
    `;

    $("#alert").html(alertHtml);

    // im fokus text disable
    $(".ausblendenbutton").click(function (e) {
      e.preventDefault();
      $(".imfokustext").toggleClass("hide");
      alertShown = !alertShown;
      $(this).text((i, text) =>
        text === "Einblenden" ? "Ausblenden" : "Einblenden"
      );
      localStorage.setItem(
        "alertstatus",
        alertShown === true ? "show" : "hide"
      );
    });

    // WEB SHARE API WITH FALLBACK

    // get current url from copylink data
    const copyLink = $("#copyLink").data();
    if (copyLink) {
      const currentLinkUrl = copyLink.copylinkurl;
      const currentSiteTitle = copyLink.currenttitle;
      const fullSiteTitle = `${currentSiteTitle} - Bayreuth Tourismus`;
    }

    $(".share-button").on("click", (e) => {
      e.preventDefault();

      const currentLinkUrl = copyLink.copylinkurl;
      const currentSiteTitle = copyLink.currenttitle;
      const fullSiteTitle = `${currentSiteTitle} - Bayreuth Tourismus`;

      if (navigator.share) {
        navigator
          .share({
            title: fullSiteTitle || "",
            url: currentLinkUrl || "",
          })
          .then(() => {})
          .catch(console.error);
      } else {
        $(".share-dialog").toggleClass("is-open");
        $(".share-button").toggleClass("share-dialog-open");
      }
    });

    if (copyLink) {
      $("#copyLink").on("click", (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(copyLink.copylinkurl).then(
          () => {
            $("#copylinktext").text("Link kopiert ✓");
          },
          (error) => {
            console.error("Link konnte nicht kopiert werden: ", error);
          }
        );
      });
    }

    const shareBtn = document.getElementById("shareBtn");
    if (shareBtn) {
      shareBtn.onclick = function () {
        const currentLinkUrl = copyLink.copylinkurl;
        const currentSiteTitle = copyLink.currenttitle;
        const fullSiteTitle = `${currentSiteTitle} - Bayreuth Tourismus`;

        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            currentLinkUrl
          )}`,
          "facebook-share-dialog",
          "width=626,height=436"
        );
        return false;
      };
    }

    const tweetBtn = document.getElementById("tweetBtn");
    if (tweetBtn) {
      tweetBtn.onclick = function () {
        const currentLinkUrl = copyLink.copylinkurl;
        const currentSiteTitle = copyLink.currenttitle;
        const fullSiteTitle = `${currentSiteTitle} - Bayreuth Tourismus`;

        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            `${fullSiteTitle} - ${currentLinkUrl}`
          )}`,
          "twitter-share-dialog",
          "width=626,height=436"
        );
        return false;
      };
    }

    // MOBILE NAV MENU CLOSED
    // $(".mobile-nav--phonemail").removeClass("phonemenuclosed");
    // $(window).scroll(function () {
    //   setTimeout(function () {
    //     var scroll = $(window).scrollTop();
    //     if (scroll > lastScroll + 20) {
    //       $(".mobile-nav--phonemail").addClass("phonemenuclosed");
    //     } else if (scroll < lastScroll - 20) {
    //       $(".mobile-nav--phonemail").removeClass("phonemenuclosed");
    //     }
    //     lastScroll = scroll;
    //   }, 500);
    // });
  });

  // Ajax Menu Call Start

  $(".menu-hauptmenu-container > ul > li > ul").append(
    "<div class='ajaxmenu'></div>"
  );

  $("#primary-menu a").on("mouseenter", function () {
    const $el = $(this);
    const menuPreviewData = $el.data("menuPreview");
    if (!menuPreviewData || !menuPreviewData.featured_img_src) {
      return;
    }

    // console.log("MENU URL");
    // console.log(menuPreviewData);

    const menuPreview = `
    <a href="${menuPreviewData.url}">
        <img src="${menuPreviewData.featured_img_src}" alt="${menuPreviewData.title_attr}" class="iexfit">
    </a>
    <a href="${menuPreviewData.url}">
        <h2>${menuPreviewData.title}</h2>
        <p>${menuPreviewData.excerpt}</p>
    </a>
    `;

    $(".ajaxmenu").empty().append(menuPreview);
  });

  $("#primary-menu > li").mouseenter(function (e) {
    e.preventDefault();
    let page_id = $(this).attr("class").split("page_id-").pop();
    page_id = parseInt(page_id);
  });

  // Main Menu Nav Indicator

  $(".menu-hauptmenu-container > ul > li > a").focus(function () {
    $(".menu-hauptmenu-container > ul > li").removeClass("force-show");
    $(this).parent().addClass("force-show");
  });
  $(".menu-hauptmenu-container > ul > li > ul > li > a").focus(function () {
    $(".menu-hauptmenu-container > ul > li > ul > li").removeClass(
      "force-show"
    );
    $(this).parent().addClass("force-show");
  });

  $(document).click(() => {
    $(".menu-hauptmenu-container > ul > li").removeClass("force-show");
  });
  // Menu Animation Upgrades
  const handleone = function (el) {
    const $el = $(el);
    $el.addClass("mainselect").siblings().removeClass("mainselect");
  };

  $("ul#primary-menu > li").on("mouseenter", function (event) {
    handleone(this);
  });

  $("#primary-menu > li > ul").mouseleave(() => {
    $(".menu-hauptmenu-container > ul > li").removeClass("mainselect");
  });

  $("#primary-menu").mouseleave(() => {
    $(".menu-hauptmenu-container > ul > li").removeClass("mainselect");
  });

  const handle = function (el) {
    const $el = $(el);
    $el.addClass("selected").siblings().removeClass("selected");

    $(".selected:before")
      .css("left", `${$el.position().left}px`)
      .css("height", `${$el.height()}px !important`)
      .css("padding-left", $el.css("padding-left"))
      .css("padding-right", $el.css("padding-right"));
  };

  // Click handler
  $("ul#primary-menu li > ul > li").on("mouseover", function (event) {
    handle(this);
  });

  // $(".prospektForm").fancybox();
  // Frontpage Header Image Coloring

  $(document).ready(() => {
    $(".bannerimage").addClass("colorin-header-mobile");
  });

  $(document).ready(() => {
    $(".herowrapper").mouseenter(() => {
      $(".bannerimage").addClass("colorin-header");
    });
  });

  // moveTo
  document.addEventListener("DOMContentLoaded", () => {
    const easeFunctions = {
      easeInQuad(t, b, c, d) {
        t /= d;
        return c * t * t + b;
      },
      easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
      },
    };
    const moveTo = new MoveTo(
      {
        ease: "easeInQuad",
      },
      easeFunctions
    );
    const triggers = document.getElementsByClassName("js-trigger");
    for (let i = 0; i < triggers.length; i++) {
      moveTo.registerTrigger(triggers[i]);
    }
  });

  //  Replace all SVG images with inline SVG
  jQuery("img.svg").each(function () {
    const $img = jQuery(this);
    const imgID = $img.attr("id");
    const imgClass = $img.attr("class");
    const imgURL = $img.attr("src");

    jQuery.get(
      imgURL,
      (data) => {
        // Get the SVG tag, ignore the rest
        let $svg = jQuery(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", `${imgClass} replaced-svg`);
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });

  // Flatpickr Init
  const fp = flatpickr("#startdate", {
    mode: "range",
    plugins: [new rangePlugin({ input: "#enddate" })],
    showMonths: 2,
    minDate: "today",
    dateFormat: "d.m.Y",
    locale: German,
    onClose(selectedDates, dateStr, instance) {
      $("#personen").focus();
    },
  });

  $("#startdate, #enddate").on("click", () => {
    fp.clear();
  });

  // IFrame Loader Remove
  // $("#buchungsiframe").load(function() {
  //   $("#loaderimage").remove();
  // });

  /*

    SELF MADE CALENDAR FRONT PAGE

    */

  // console.log("TEST");

  $(document).ready(() => {
    const bookingEle = document.getElementById("buchungsiframe");
    if (bookingEle) {
      bookingEle.onload = function () {
        $(".ajax-loader2").hide();
      };
    }

    // var today = moment().format("YYYYMMDD");

    // var json_url =
    //   siteUrl +
    //   "/wp-json/wp/v2/eventkalender?filter[meta_key]=startdate&filter[meta_value]=" +
    //   today +
    //   "&filter[orderby]=meta_value_num&filter[order]=asc&per_page=10";

    // $.ajax({
    //   dataType: "json",
    //   url: json_url,
    // })
    //   .done(function (response) {
    //     if (response.length <= 0) {
    //       $(".ajax-loader").hide();
    //       $(".eventcontent").append("<p>Keine Veranstaltungen gefunden.</p>");
    //     } else {
    //       $.each(response, function (index, object) {
    //         //FOrmat startdate
    //         var startdate = moment(object.acf.startdate, "YYYYMMDD").format(
    //           "DD.MM.YYYY"
    //         );
    //         var related_loop =
    //           "<a href='" +
    //           object.link +
    //           "' rel='bookmark' class='indexitem eventitem' data-wpel-link='internal'>" +
    //           "<article  class='indexarticle post-2428 news type-news status-publish has-post-thumbnail hentry first'>" +
    //           "<span class='orient'>" +
    //           startdate +
    //           "</span>" +
    //           "<h2 class='entry-title'>" +
    //           object.title.rendered +
    //           "</h2><div class='calexcerpt'>" +
    //           object.excerpt.rendered +
    //           "</div>" +
    //           "<p class='mehr'>Mehr erfahren</p>" +
    //           "</article></a>";
    //         $(".ajax-loader").hide();
    //         $(".rightcalcontent").append(related_loop);
    //       });
    //     }
    //   })
    //   .fail(function () {})
    //   .always(function () {
    //     var weitereEvents =
    //       "<a href='/eventkalender'><span class='button' style='margin-top: 4rem;'>Weitere Events im Kalender</span></a>";
    //     $(".rightcalcontent").append(weitereEvents);
    //   });
  });

  $(document).ready(() => {
    $(".caldays").on("click", function () {
      $(".rightcalcontent").empty();
      $(".ajax-loader").show();

      var clickedday = $(this).data("day");

      const today = clickedday;

      var clickedday = $(this).data("day");
      $(".todaymarker").removeClass("todaymarker");
      $(this).addClass("todaymarker");

      const json_url = `${siteUrl}/wp-json/wp/v2/eventkalender?filter[meta_key]=startdate&filter[meta_value]=${today}&filter[orderby]=meta_value_num&filter[order]=asc&per_page=10`;

      $.ajax({
        dataType: "json",
        url: json_url,
      })
        .done((response) => {
          if (response.length <= 0) {
            $(".ajax-loader").hide();

            $(".rightcalcontent").append(
              "<p>Keine Veranstaltungen gefunden.</p>"
            );
          } else {
            $.each(response, (index, object) => {
              // FOrmat startdate
              const startdate = moment(object.acf.startdate, "YYYYMMDD").format(
                "DD.MM.YYYY"
              );
              const related_loop =
                `<a href='${object.link}' rel='bookmark' class='indexitem eventitem' data-wpel-link='internal'>` +
                "<article  class='indexarticle post-2428 news type-news status-publish has-post-thumbnail hentry first'>" +
                `<span class='orient'>${startdate}</span>` +
                `<h2 class='entry-title'>${object.title.rendered}</h2><div class='calexcerpt'>${object.excerpt.rendered}</div>` +
                "<p class='mehr'>Mehr erfahren</p>" +
                "</article></a>";
              $(".ajax-loader").hide();
              $(".rightcalcontent").append(related_loop);
            });
          }
        })
        .fail(() => {})
        .always(() => {
          const weitereEvents =
            "<a href='/eventkalender'><span class='button' style='margin-top: 4rem;'>Weitere Events im Kalender</span></a>";
          $(".rightcalcontent").append(weitereEvents);
        });
    });
  });

  // Wanderweg Total Time Override

  // $(document).ready(function () {
  //   const totaltime = document.querySelectorAll(".totaltime");
  //   if (totaltime !== null) {
  //     totaltime.forEach(
  //       (element) => (element.firstElementChild.textContent = "Gesamtzeit")
  //     );
  //   }
  // });

  $(document).ready(() => {
    const summaryvalue = document.querySelectorAll(".summaryvalue");
    if (summaryvalue.length !== 0) {
      const hikelength = summaryvalue[0].innerText;
      const hikemeter = parseInt(
        hikelength.substring(0, hikelength.length - 2)
      );
      if (hikemeter > 999) {
        const hikekm = `${(hikemeter / 1000).toFixed(1)} km`;
        const lengthvalue = document.querySelectorAll(".totlen>.summaryvalue");
        if (lengthvalue !== null) {
          lengthvalue.forEach((element) => {
            element.textContent = hikekm;
          });
        }
      }
    }

    const totlen = document.querySelectorAll(".totlen");
    if (totlen !== null) {
      totlen.forEach(
        (element) =>
          (element.firstElementChild.innerHTML = `<img src='${siteUrl}/wp-content/themes/bmtg/img/touren/arrows-left-right.svg' width='15px' height='15px' alt='Gesamtstrecke' /> `)
      );
    }
    const totaleleup = document.querySelectorAll(".totaleleup");
    if (totaleleup !== null) {
      totaleleup.forEach(
        (element) =>
          (element.firstElementChild.innerHTML = `<img src='${siteUrl}/wp-content/themes/bmtg/img/touren/arrow-up-right.svg' width='10px' height='10px' alt='Anstieg' /> `)
      );
    }
    const totaleledown = document.querySelectorAll(".totaleledown");
    if (totaleledown !== null) {
      totaleledown.forEach(
        (element) =>
          (element.firstElementChild.innerHTML = `<img src='${siteUrl}/wp-content/themes/bmtg/img/touren/arrow-down-right.svg' width='10px' height='10px' alt='Abstieg' /> `)
      );
    }

    const totaleledownvalue = document.querySelectorAll(
      ".totaleledown>.summaryvalue"
    );

    if (totaleledownvalue !== null) {
      totaleledownvalue.forEach((element) => {
        const str = element.innerText;
        const res = str.substring(1);
        element.textContent = res;
      });
    }

    // const totaltime = document.querySelectorAll(".totlen");
    // if (totaltime !== null) {
    //   totaltime.forEach(
    //     // (element) => (element.firstElementChild.textContent = "Schwachfug")
    //     (element) => {
    //       const textcontent = element;
    //       console.log("textcontent", textcontent[0]);
    //     }
    //   );
    // }
    // const downloadFile = document.querySelectorAll(".totaltime");
    // if (totaltime !== null) {
    //   totaltime.forEach(
    //     // (element) => (element.firstElementChild.textContent = "Gesamtzeit")
    //     (element) => {
    //       const textcontent = element.textContent;
    //       console.log("textcontent", textcontent);
    //     }
    //   );
    // }
  });

  // The End of it All
})(jQuery);
